<div
  class="systoast"
  *ngFor="let n of toasts$ | async; trackBy: trackByKey"
  [class.warn]="n.severity === 'warn'"
  [class.info]="n.severity === 'info'"
  [class.success]="n.severity === 'success'"
  [@toast]
  (click)="dismiss(n.key)"
>
  <span class="systoast__icon">
    <mat-icon class="material-symbols-outlined">{{ iconFor(n.severity) }}</mat-icon>
  </span>
  <span class="systoast__msg">{{ n.message }}</span>
</div>
